import { render } from "./WpeDivider.vue?vue&type=template&id=61e5fad7"
import script from "./WpeDivider.vue?vue&type=script&lang=js"
export * from "./WpeDivider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/options-controls/WpeDivider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61e5fad7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61e5fad7', __exports__)) {
    api.reload('61e5fad7', __exports__)
  }
  
  module.hot.accept("./WpeDivider.vue?vue&type=template&id=61e5fad7", () => {
    api.rerender('61e5fad7', render)
  })

}


export default __exports__